'use strict';

require('../../picker/style/');